import { motion } from "framer-motion";
import { CheckCircle2, Zap, Shield, Globe } from "lucide-react";

const liveSupervisors = [
  { name: "Apollo (Vision AI)", status: "live", icon: CheckCircle2 },
  { name: "Echo (AI Receptionist)", status: "live", icon: CheckCircle2 },
  { name: "Athena (SOP Builder)", status: "live", icon: CheckCircle2 },
  { name: "Voice Calls (VAPI)", status: "live", icon: Zap },
  { name: "AI Argus Chat", status: "live", icon: CheckCircle2 },
  { name: "Voice Onboarding", status: "live", icon: CheckCircle2 },
  { name: "Atlas (Staff Sync)", status: "coming_soon", icon: Shield },
  { name: "POS Integration", status: "coming_soon", icon: Globe },
];

export const SystemStatus = () => {
  return (
    <section data-testid="system-status" className="py-16 border-y border-gold/10 bg-indigo-700/20">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div 
          className="flex flex-col md:flex-row items-center justify-between gap-8"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          {/* Status indicator */}
          <div className="flex items-center gap-4">
            <div className="relative">
              <div className="w-4 h-4 rounded-full bg-green-500 animate-pulse" />
              <div className="absolute inset-0 w-4 h-4 rounded-full bg-green-500 animate-ping opacity-50" />
            </div>
            <div>
              <span className="text-green-400 font-bold text-sm">ALL SUPERVISORS ONLINE</span>
              <p className="text-xs text-slate-400">Last updated: {new Date().toLocaleDateString()}</p>
            </div>
          </div>
          
          {/* Feature pills */}
          <div className="flex flex-wrap justify-center gap-2">
            {liveSupervisors.map((feature, i) => {
              const Icon = feature.icon;
              const isLive = feature.status === "live";
              return (
                <motion.div
                  key={feature.name}
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.05 }}
                  className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full border ${
                    isLive
                      ? "bg-green-500/10 border-green-500/20"
                      : "bg-amber-500/10 border-amber-500/20"
                  }`}
                >
                  <Icon className={`w-3 h-3 ${isLive ? "text-green-400" : "text-amber-400"}`} />
                  <span className={`text-xs font-medium ${isLive ? "text-green-300" : "text-amber-300"}`}>
                    {feature.name}{!isLive ? " (Soon)" : ""}
                  </span>
                </motion.div>
              );
            })}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
